// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__1vLjM","backLink":"Detail_backLink__3zDil"};